import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const ClientColumns: TableColumn[] = [
    {
        name: "name", 
        displayName: "Name", 
        dataType: COLUMN_TYPES.string, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "company", 
        displayName: "Company", 
        dataType: COLUMN_TYPES.string, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "dateAccredited", 
        displayName: "Date Accredited", 
        dataType: COLUMN_TYPES.date, 
        isEditable: false, 
        isEditableOnNew: true, 
        styles: {width: '20%'},
        reference: '',
        selectOptions: null
    }
  ];


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.client.list.ts